/**
 * created by tian ruo jun
 * 拾取稿件组件
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Scrollbars} from "react-custom-scrollbars";
import {message, Modal} from "antd";
import {showStoryUrlConfig} from "../showStoryUrl-config";
import BaseComponent from "../../../../base/BaseComponent";

const {confirm} = Modal;

export default class RenderPicker extends BaseComponent {
    static defaultProps = {
        id: "",
        data: {},
        widthValue: 230,
        paddingRight: 0
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            treeData: []
        }
    }

    componentWillMount() {
        if(!this.props.treeData) {
            this.getCurrentUserMediaList()
        } else {
            this.state.treeData = this.props.treeData
        }
    }

    componentDidMount() {
    }

    render() {
        let {id,data,widthValue,mediaClick,paddingRight} = this.props;
        let {treeData} = this.state;
        if(treeData && treeData.length){
            let mediaTypes = this.sysConfigGetValueByKey("shiqu.media.type", "webNews,material,rmapp").split(",");
            treeData = treeData.filter(item=>{
                return mediaTypes.indexOf(item.mediaTypeCode) > -1;
            });
        }
        return (
            <div style={{width:widthValue,lineHeight:2}}>
                <Scrollbars style={{width:widthValue?widthValue:230,paddingRight:paddingRight}}
                            autoHeight={true}
                            autoHeightMax={400}
                >
                    {treeData && treeData.length ? (
                        treeData.map((picker,index)=>{
                            return (
                                <div key={index}>
                                    {this.renderPickerItem({picker,id,data,mediaClick})}
                                </div>
                            )
                        })
                    ):null}
                </Scrollbars>
            </div>
        )
    }

    // 渲染拾取器
    renderPickerItem = ({picker,id,data,mediaClick}) => {
        return (
            <>
                <div style={{display: 'flex',alignItems: 'center'}}>
                    {/*<Icon type="border-outer" />*/}
                    <img src={picker.logoUrl} width={16} style={{marginRight:5}}/>
                    <div style={{color:"#a0a0a0"}}>{picker.mediaTypeName}</div>
                </div>
                <div>
                    {picker && picker.mediaList && picker.mediaList.length ?(
                        picker.mediaList.map((media,index)=>{
                            let checked = media.checked;
                            return (
                                media.authResult === 1 ?
                                    <div className={`text-pointer text-pointer-color ${checked?"text-pointer-checked":""}`} onClick={()=>{
                                        let setCheckStatus = () => {
                                            this.state.treeData.forEach(item1 => {
                                                item1.mediaList.forEach(item2 => {
                                                    item2.checked = false;
                                                    if (item1.id === picker.id && media.id === item2.id) {
                                                        item2.checked = checked ? false : true;
                                                    }
                                                })
                                            });
                                            this.setState({});
                                        };
                                        if(typeof mediaClick === "function"){
                                            mediaClick(media);
                                            setCheckStatus();
                                            return
                                        }
                                        this.onClickPicker({media,id,data})
                                    }} style={{padding:"4px 0 4px 21px",cursor:'pointer'}} key={index}>
                                        {media.name}
                                    </div>
                                    :
                                    <div className={"text-pointer text-pointer-color"} onClick={()=>{
                                        message.destroy();
                                        message.warning("不可拾取至未认证媒体！");
                                    }
                                    } style={{padding:"4px 0 4px 21px",cursor:'pointer'}} key={index}>
                                        {media.name + "（未认证）"}
                                    </div>
                            )
                        })
                    ):null}
                </div>
                <style>
                    {
                        `
                        .text-pointer-color {border:1px solid transparent}
                        .text-pointer-color:hover {border-color:#E2EBF6;background:#F5F8FC}
                        .text-pointer-checked {border:1px solid #E2EBF6;background:#F5F8FC}
                         `
                    }
                </style>
            </>
        )
    };

    getCurrentUserMediaList = ()=>{
        this.request({
            url : "/cm-sites-pms/media/getCurrentUserMediaGroupByType",
            callBack: (data)=>{
                // 过滤禁用的媒体
                let newData = data && data.map(item=>({
                    ...item,
                    mediaList: item.mediaList && item.mediaList.filter(media=>{
                        return  media.disable == 0;
                    })
                }));
                // 素材中心这里只保留网站和微信稿件
                if(newData){
                    let mediaTypes = this.sysConfigGetValueByKey("shiqu.media.type", "webNews,material").split(",");
                    newData = newData.filter(item=>{
                        return mediaTypes.indexOf(item.mediaTypeCode) > -1;
                    });
                }
                this.setState({
                    treeData: newData
                });
            }
        })
    };

    //点击拾取按钮
    onClickPicker = ({media={},id=0,data=null}) => {
        let mediaNewsType = media.mediaTypeCode;
        if(!mediaNewsType || !id) return message.info("参数丢失");
        this.jumRoute(media,(res)=>{
            if(res) {
                this.pickerFunc({medialId:media.id,mediaNewsType,id,data});
            } else {
                message.destroy();
                message.error('请联系管理员绑定网站用户管理员！')
            }
        });
    };

    //媒体绑定事件
    jumRoute(media,call) {
        //获取当前用户所有可以访问的角色权限
        let windowRoleList = [];
        window.currentUser && window.currentUser.roleList && window.currentUser.roleList.length && window.currentUser.roleList.forEach((item) => {
            item.menuCods && item.menuCods.length && item.menuCods.forEach((Item) => {
                windowRoleList.push(Item)
            })
        });
        if(windowRoleList.indexOf(media.mediaTypeCode) == -1){
            message.destroy();
            message.warning("请设置媒体系统权限!");
            return;
        };
        if (media.mediaTypeCode == 'webNews' && media.authResult == 1) {
            this.mediaBinding(media, (res) => {
                if (!res) {
                    call&&call(false)
                } else {
                    call&&call(true)
                }
            })
        }else if(media.mediaTypeCode == 'webNews' && media.authResult == 0){
            message.destroy()
            message.error('媒体未认证，请在媒体管理中对媒体进行认证！')
        }
        else if (!(media.mediaTypeCode == "material" && media.authResult == 0)) {
            call&&call(true)
        }
        else if (!(media.mediaTypeCode == "rmapp")) {
            call&&call(true)
        }
    }

    //媒体绑定功能
    mediaBinding = (media, callback) => {
        this.request({
            url: '/cm-sites-pms/website/getVsbUser',
            body: {
                mediaId: media.id,
                userId: window.currentUser.id
            },
            callBack: (res) => {
                callback(res)
            },
            serverVerify:{
                serverErrorCallBack:()=>{
                    message.destroy();
                    message.error('请联系管理员添加融媒发布媒体权限！')
                },
                isShowErrorMsg:false
            },
            errorCallBack: (e) => {
            },
        })
    };

    // 拾取操作
    pickerFunc = ({medialId,mediaNewsType,id,data}) => {
        if(mediaNewsType && id && (typeof (this["pickerFuncTo"+mediaNewsType]) == 'function')) {
            this["pickerFuncTo"+mediaNewsType]({medialId,mediaNewsType,id,data})
        }
    };

    // 拾取到网站
    pickerFuncTowebNews = ({mediaNewsType,id}) => {
        let that = this;
        let body = {mediaNewsType,storyId:id};
        let config  = showStoryUrlConfig[mediaNewsType] || {};
        let urls = config['urls'] || {};
        let url = urls['pickerUrl'];
        let configName = config['pickerModule']; // 拾取稿件到网站，应该直接用网站编辑器打开
        if (!(id && id.length > 1 && url && mediaNewsType && configName)) {
            return;
        }
        that.state.operateType = "pickUp";
        that.state.storyId = id;
        this.request({
            url,
            body,
            callBack: function (res) {
                let webStory = {};
                let id = 0;
                if (res) {
                    webStory =  res
                    // 拾取稿件每次都是新增，不需要传递id
                }
                that.state.webStory = webStory;
                //获取投稿流程的code
                let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.conf.name.wzlc", "activitiTreeRoot-xlc-wzlc");
                that.state.editorWindow = window.openEditById({configName, id, params:{
                        activitiConfName,
                        webStory,
                        storyId: that.state.storyId,
                        operateType: "contribute"
                    }})
            },
            errorCallBack: function (res) {
                message.error('稿件加载失败！');
            }
        });
    };

    // 拾取到微信
    pickerFuncTomaterial = ({medialId,mediaNewsType,id,data}) => {
        if(medialId && data) {
            // 等同于在合成器中添加了一篇文章然后提交公众号
            this.addWechat({
                medialId,
                wechatList:[data]
            })
        } else {
            message.info("参数丢失");
        }
    };

    // 拾取到融媒号
    pickerFuncTormapp = ({medialId,mediaNewsType,id,data}) => {
        let that = this;
        let body = {storyId:id};
        let config  = showStoryUrlConfig[mediaNewsType] || {};
        let url = config['url'];
        let configName = config['module'];
        if (!(id && id.length > 1 && url && mediaNewsType && configName)) {
            return;
        }
        that.state.operateType = "pickUp";
        that.state.storyId = id;
        this.request({
            url,
            body,
            callBack: function (res) {
                let mediaFusion = {};
                let id = 0;
                if (res) {
                    mediaFusion =  res
                    // 拾取稿件每次都是新增，不需要传递id
                }
                that.state.mediaFusion = mediaFusion;
                //获取投稿流程的code
                let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.conf.name.wzlc", "activitiTreeRoot-rmapp");
                that.state.editorWindow = window.openEditById({configName, id, params:{
                        activitiConfName,
                        mediaFusion,
                        storyId: that.state.storyId,
                        operateType: "contribute"
                    }})
            },
            errorCallBack: function (res) {
                message.error('稿件加载失败！');
            }
        });
    };

    // 新增微信图文
    addWechat = ({medialId, wechatList}) => {
        if(wechatList&&wechatList.length&&medialId) {
            let url = "/cm-sites/pms/framereact/index.html#/wechat/weiChatPublish/"+medialId;
            let addFun = () => {
                let stuffList = wechatList.map(item=>({
                    title: item.title,
                    author: item.submitterName,
                    titlePic: item.titlePic,
                    summary: (item.variableFields && item.variableFields.summary) ? item.variableFields.summary  : "",
                    content: this.filterContent(item.content),
                    url: item.url,
                    id: item.id,
                    storyId: item.id,
                    afterFun: ["saveRelation"],
                }));
                window.openPage({
                    url,
                    params: {
                        stuffList,
                    },
                })
            };
            if(this.checkWechat(wechatList)) {
                addFun()
            } else {
                confirm({
                    title: '公众号编辑器不支持插入音视频，稿件中的音视频将会删除',
                    onOk:() =>{
                        addFun()
                    },
                    onCancel() {
                    },
                });
            }
        }
    };

    checkWechat = (wechatList) => {
        if(wechatList && wechatList.length) {
            return wechatList.some(item=>{
                let content = item.content;
                let regStr =
                    "(<\/?video.*?>)" +
                    "|(<\/?audio.*?>)" +
                    "|(<\/?[^>]*alias-label=\"video\".*?>)" +
                    "|(<\/?[^>]*alias-label=\"audio\".*?>)" +
                    "|(<\/?[^>]*video-src=.*?>)" +
                    "|(<\/?[^>]*audio-src=.*?>)";
                let reg = new RegExp(regStr,"g");
                let hasVideo = reg.test(content);
                return !hasVideo
            });
        } else {
            return true
        }
    };

    filterContent = (content) => {
        if(content) {
            // 过滤视频音频标签，以及以图片形式存储的视频音频标签（video-src   alias-label="video"）
            let regStr =
                "(<\/?video.*?>)" +
                "|(<\/?audio.*?>)" +
                "|(<\/?[^>]*alias-label=\"video\".*?>)" +
                "|(<\/?[^>]*alias-label=\"audio\".*?>)" +
                "|(<\/?[^>]*video-src=.*?>)" +
                "|(<\/?[^>]*audio-src=.*?>)";
            let reg = new RegExp(regStr,"g");
            let newContent = content.replace(reg,"");
            return newContent
        } else {
            return content
        }
    };





}